export default "__VITE_ASSET__DgSuLV2$__"